import { underscore } from '@ember/string';

export const FILTER_TYPES = {
  THEME:             'themeId',
  GENERATION_EFFORT: 'generationEffortId',
  PARAMETER_GROUP:   'parameterGroupId',
  IS_MODELED:        'catalogItemsIsModeled',
  LOCATION_TYPE:     'locationTypeId',
  UNIFIED_REGION:    'unifiedRegionId',
  REGION:            'regionId',
  STATE:             'stateId',
  ITEM_TYPE:         'itemStructureId',
  PARAMETER:         'parameterId',
};

export function filterType(type) {
  return FILTER_TYPES[underscore(type).toUpperCase()];
}

export function filterTypes(types) {
  return types.map(filterType);
}

export const FILTER_TYPE_NAMES = {
  // Uncomment to give explicit rename
  // [FILTER_TYPES.THEME]:             'Catalog Theme',
  // [FILTER_TYPES.GENERATION_EFFORT]: 'Generation Effort',
  // [FILTER_TYPES.PARAMETER_GROUP]:   'Parameter Group',
  // [FILTER_TYPES.IS_MODELED]:        'Modeled/Observed',
  // [FILTER_TYPES.LOCATION_TYPE]:     'Location Type',
  // [FILTER_TYPES.UNIFIED_REGION]:    'Unified Region',
  // [FILTER_TYPES.REGION]:            'Region Type',
  // [FILTER_TYPES.STATE]:             'State',
  // [FILTER_TYPES.ITEM_TYPE]:         'Data Structure',
  // [FILTER_TYPES.PARAMETER]:         'Parameter Name',
};

export function filterTypeToName(type, defaultName) {
  return FILTER_TYPE_NAMES[type] || defaultName;
}

export function filterRename(filter) {
  const name = filterTypeToName(filter.key);
  return name ? { ...filter, label: name } : filter;
}

export function filterFilter(hiddenFilters) {
  return filter => !hiddenFilters.includes(filter.key);
}

export function filtersSort(filterOrder) {
  return (a, b) => {
    a = filterOrder.indexOf(a.key);
    if (a < 0) {
      a = Infinity;
    }
    b = filterOrder.indexOf(b.key);
    if (b < 0) {
      b = Infinity;
    }
    return a < b ? -1 : a > b ? 1 : 0;
  };
}
